var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3536 0.646504C13.2816 0.57419 13.1891 0.525721 13.0886 0.507642C12.9882 0.489562 12.8846 0.502743 12.7919 0.545404L0.791857 6.0454C0.691338 6.09143 0.608906 6.16946 0.557453 6.26731C0.506001 6.36516 0.488428 6.47731 0.507485 6.58621C0.526541 6.69511 0.581152 6.79462 0.662775 6.86918C0.744399 6.94374 0.848433 6.98915 0.958607 6.9983L6.53696 7.4633L7.00196 13.0417C7.01111 13.1518 7.05652 13.2559 7.13108 13.3375C7.20564 13.4191 7.30516 13.4737 7.41405 13.4928C7.52295 13.5118 7.6351 13.4943 7.73295 13.4428C7.8308 13.3914 7.90883 13.3089 7.95486 13.2084L13.4549 1.2084C13.4973 1.1156 13.5104 1.01203 13.4923 0.911591C13.4742 0.811153 13.4258 0.718654 13.3536 0.646504ZM7.84011 11.0584L7.49856 6.95835C7.48875 6.84049 7.43747 6.72991 7.35383 6.64628C7.2702 6.56264 7.15963 6.51137 7.04176 6.50155L2.94176 6.16L11.9847 2.0154L7.84011 11.0584Z",
    fill: "#04001E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/Navigation.62d4eb5054a480d6ea50c6b088a30303.svg";
export { ForwardRef as ReactComponent };